export const OPTUM_BACKFILL_JOB_TYPE = 'optum_835_backfill';

function positiveInteger(value, label) {
  const normalized = String(value || '').trim();
  if (!/^[1-9]\d*$/.test(normalized) || !Number.isSafeInteger(Number(normalized))) {
    throw new Error(`${label} must be a positive whole number.`);
  }
  return Number(normalized);
}

function parseDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '') || value.startsWith('0000')) {
    throw new Error('Both Payment Dates are required and must be valid dates.');
  }
  const parsed = new Date(`${value}T00:00:00Z`);
  if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== value) {
    throw new Error('Enter valid Payment Dates.');
  }
  return parsed;
}

function subtractUtcMonths(value, months) {
  const year = value.getUTCFullYear();
  const monthIndex = value.getUTCMonth() - months;
  const targetYear = year + Math.floor(monthIndex / 12);
  const targetMonth = ((monthIndex % 12) + 12) % 12;
  const lastDay = new Date(Date.UTC(targetYear, targetMonth + 1, 0)).getUTCDate();
  return new Date(Date.UTC(targetYear, targetMonth, Math.min(value.getUTCDate(), lastDay)));
}

export function buildOptumBackfillParams(
  { siteId, loginId, fromDate, toDate },
  now = new Date(),
) {
  const site = positiveInteger(siteId, 'Site ID');
  const login = positiveInteger(loginId, 'Stored login ID');
  const start = parseDate(fromDate);
  const end = parseDate(toDate);
  const days = (end - start) / 86400000 + 1;
  if (days < 1 || days > 31) {
    throw new Error('Use an inclusive Payment Date range of at most 31 days, with the end on or after the start.');
  }
  const today = new Date(`${now.toISOString().slice(0, 10)}T00:00:00Z`);
  if (end >= today) {
    throw new Error('The Payment to date must be before today (UTC).');
  }
  if (start < subtractUtcMonths(today, 13)) {
    throw new Error('Optum Pay exposes at most the last 13 calendar months.');
  }
  const format = value => {
    const [year, month, day] = value.split('-');
    return `${month}/${day}/${year}`;
  };
  return {
    site_id: site,
    login_id: login,
    from_date: format(fromDate),
    to_date: format(toDate),
  };
}

export function optumBackfillError(values, now) {
  try {
    buildOptumBackfillParams(values, now);
    return '';
  } catch (error) {
    return error.message;
  }
}

export function optumCreateError(detail) {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map(item => item?.msg).filter(message => typeof message === 'string');
    if (messages.length) return messages.join(' ');
  }
  return 'Failed to create Optum Pay backfill. Check the site, stored login ID, and dates.';
}
